var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgV1White(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.222 6c.467 3.57 1.045 6.724 1.736 9.457h.124c.69-2.741 1.27-5.895 1.736-9.457h3.222c-.642 4.602-1.49 8.601-2.549 12H2.55C1.49 14.602.642 10.603 0 6h3.222z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 0v21h-3.196V0h3.197z",
    fill: "#FEDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.103 1.5H33V18h-3.197V5.04h-.124l-1.487 1.02-1.586-2.168 3.497-2.39V1.5z",
    fill: "#fff"
  })));
}

export default SvgV1White;